import $ from 'jquery';
import { LatLng } from 'leaflet/src/geo/LatLng';
import { LatLngBounds } from 'leaflet/src/geo/LatLngBounds';
import { TileLayer } from 'leaflet/src/layer/tile/TileLayer';
import * as i18n from 'i18n-setup';
import * as Overlay from 'overlay';
import * as Sign from 'sign';
import * as Search from 'search';
import * as Annotations from 'annotations';
import * as Forms from 'forms';
import state from 'state';

var margin = 10, // margin around the page (in mm)
    eps = 1E-9,
    loading = true,
    selectFile = $('#filename'),
    $window = $(window),
    filehash;

export var layer = {};

export function convertPos(sig) {
    return new LatLngBounds([ sig[2], sig[1] ], [ sig[4], sig[3] ]);
}

export function convertPosArray(arr) {
    return arr.map(function (v) {
        return new LatLng([ v[1], v[0] ]);
    });
}

export function popupOpts() {
    var width = $window.width(),
        opt = {};
    // responsive popup width
    if (width < 400)
        opt.maxWidth = width - 75;
    return opt;
}

function hideSpinner() {
    if (loading) {
        loading = false;
        $('#loader').fadeOut(200);
        state.pdf.triggerSafe('show');
    }
}

function updateHash() {
    var hash = '';
    if (state.fileidx > 0 || state.page > 0) {
        hash = '#' + state.fileidx;
        if (state.page > 0)
            hash += ',' + (state.page + 1);
    }
    state.hash = hash;
    if (hash != window.location.hash) // avoid triggering unuseful changes
        window.location.hash = hash;
}

export function updateFiles(json) {
    if ('files' in json)
        state.files = json.files;
    if (state.files.length <= 1)
        selectFile.parent().hide();
    else {
        selectFile.empty();
        $.each(state.files, function (i, f) {
            selectFile.append($('<option>').val(i).text(f.name));
        });
    }
    if ('index' in json)
        changeFile(json.index, true);
}

export function changePage(p, force, fit) {
    if (typeof p != 'number')
        throw new Error('First parameter must be a page number.');
    if (state.page == p && !force)
        return;
    if (!state.info) // we can't change page when we don't have document metadata
        return;
    var oldPage = state.page;
    if (p <= 0)
        p = 0;
    else if (p >= state.pageMax)
        p = state.pageMax - 1;
    state.page = p;
    updateHash();
    if (state.page === 0)
        $('#pagePrev').hide();
    else
        $('#pagePrev').show();
    if (state.page === state.pageMax - 1)
        $('#pageNext').hide();
    else
        $('#pageNext').show();
    state.panel.sign.close();
    state.map.closePopup();
    for (var l in layer)
        layer[l].clearLayers();
    var zoomOffset = 0|localStorage.w2s_zoomOffset,
        pageSize = state.info.pagesize[state.page],
        layerPage = new TileLayer(state.base + state.page + '_{z}_{x}_{y}.png', {
            attribution: 'PDF page ' + state.page,
            continuousWorld: true,
            zoomOffset: zoomOffset,
            minZoom: 0,
            maxZoom: state.info.maxzoom - zoomOffset, // the max is still "maxzoom" server side
            zoomSnap: 0.25,
            tileSize: (zoomOffset === 0) ? state.tileSize : (zoomOffset > 0) ? (state.tileSize >>> 1) : (state.tileSize << 1),
            updateWhenIdle: false,
            bounds: [ [ +eps, +eps ], [ pageSize.h - eps, pageSize.w - eps ] ]
        });
    state.map.setMaxBounds([
        [ -margin, -margin ],
        [ pageSize.h + margin, pageSize.w + margin ]
    ]);
    if (fit) // fit before adding layer so that no spurious tile is requested
        fitWidthTop({ animate: false });
    layer.page.addLayer(layerPage);
    if (loading) // hide spinner on first loaded tile
        layerPage.once('tileload', hideSpinner);
    Sign.highlight();
    Forms.highlight();
    Search.highlight();
    Annotations.load(state.page);
    state.pdf.triggerSafe('pageChanged', [ oldPage, p ]);
}

export function changeFile(f, keep, wantedPage) {
    function update() {
        state.pageMax = state.info.numpages;
        Sign.populateFields();
        if (keep)
            changePage(state.page, true);
        else
            changePage(wantedPage || 0, true, true);
    }
    if (state.fileidx == f && filehash == state.files[f].hash)
        return update();
    state.fileidx = f;
    state.file = state.files[f];
    filehash = state.file.hash;
    state.base = 'pdf/' + state.token + '/' + filehash + '/';
    state.pdf.triggerSafe('fileRequest', state.file);
    selectFile.val(state.fileidx);
    // empty outdated fields, waiting for them to be updated
    state.info = null;
    state.pageMax = 0;
    state.sigInfo = null;
    state.matches = null;
    state.formInfo = null; //TODO: define how to get this infos
    $.getJSON(state.base + 'info.json'
    ).then(function (info) {
        state.info = info;
        state.info.timestamp = Date.now(); // keep download time as timeouts are relative to this
        state.pdf.triggerSafe('fileInfo', info);
        update();
        if (!info.fields.verify)
            return;
        $.getJSON(state.base + 'verify.json'
        ).then(function (data) {
            // this might take some time
            state.sigInfo = data.sigs;
            Sign.populateFields();
            Sign.highlight();
            Forms.highlight();
            state.pdf.triggerSafe('verified', state.sigInfo);
        }).catch(function () {
            Overlay.error('Error verifying document signatures.');
        });
    }).catch(function () {
        Overlay.error('Error downloading document info.');
    });
}

export function fitWidthTop(opts) {
    var p = state.info.pagesize[state.page],
        m = state.map.getSize(),
        h = Math.min(p.h, p.w * m.y / m.x);
    state.map.fitBounds([ [ -margin, -margin ], [ h + margin, p.w + margin ] ], opts);
}

export function fitWidth(opts) {
    var p = state.info.pagesize[state.page],
        c = state.map.getCenter();
    state.map.fitBounds([ [ c.lat, -margin ], [ c.lat, p.w + margin ] ], opts);
}

export function fitPage(opts) {
    var p = state.info.pagesize[state.page];
    state.map.fitBounds([ [ -margin, -margin ], [ p.h + margin, p.w + margin ] ], opts);
}

export function say(param, callback) {
    $.postJSON(state.base + 'say', JSON.stringify(param)
    ).then(function (data) {
        if (data.error)
            return callback(data.error);
        return callback(null, data);
    }).catch(function () {
        callback(i18n.str('err.contact'));
    });
}

export function rotate(degrees, page) {
    $.postJSON(state.base + 'rotate', {
        degrees: degrees,
        page: page
    }).then(function (data) {
        if ('error' in data) {
            Overlay.error(i18n.str('sig.error') + '\n' + data.error);
            return;
        }
        state.pdf.triggerSafe('rotated', [ data ]);
        state.map.closePopup();
        updateFiles(data);
    }).catch(function () {
        Overlay.error(i18n.str('err.contact'));
    });
}

selectFile.change(function () { changeFile(this.value); });
